<select 
class="form-control"
[ngClass]="{'is-invalid':control.touched && control.invalid}"
[id]="id"
[name]="id"
[title]="title"
[class.opacity-65]="control.disabled === true"

[formControl]="control">
<option value="" selected [attr.disabled]="enabledDefaultOption === true ? null : true" >{{placeholder}}</option>
<option *ngFor="let e of dataSelect" [value]="e?.id > -1 ? e.id : e.id || e.value || e.label || e.name || e.text || e">
    {{e.label || e.text || e.name || e}}
    </option>
</select> 